import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Scrollbars from 'react-custom-scrollbars';
import { useTranslation } from 'react-i18next'

import { VideoBanner } from '../../../components';

interface IHotelDetailPopupProps {
    buttonElemnts: any,
    hoteltitle: String
}

const HotelDetailPopup: React.FC<IHotelDetailPopupProps> = ({ buttonElemnts, hoteltitle }) => {
    const [showMenu, setShowMenu] = useState(false)
    const { t } = useTranslation()
    const handleShowMenu = (event: React.MouseEvent) => {
        event.preventDefault()
        setShowMenu(true)
    }
    const handleCloseMenu = () => setShowMenu(false)

    return (
        <div className={'popup-toggle'}>
            <button onClick={handleShowMenu}>
                {buttonElemnts}
            </button>

            {showMenu ?
            <div className="popup-body">
                <main className="main-wrapper">
                    <div className="popup-header clearfix">
                        <div className="popup-title">
                            <h4>{hoteltitle}</h4>
                        </div>
                        <div className="close_icon">
                            <button onClick={handleCloseMenu}>
                                {t('CLOSE')}
                                <img src="/images/icons/close-icon.png" alt="close" />
                            </button>
                        </div>
                    </div>
                    <Scrollbars className="scroll-wrapper" >
                        <div className="body-wrapper clearfix p-t10 p-lr0 hotel-popup-wrapper">
                            <VideoBanner />
                            <div className="row">
                                <div className="columns medium-8 p-t30">
                                    <p>
                                        <img src="/images/icons/icon-location.png" alt="icon-location" className="p-r5" />
                                        Mitte, 6.7 km to city centre
                                    <small className="p-l5"><Link to={'/'}>View on map</Link></small>
                                    </p>
                                    <p>
                                        Your Connection to nature. You can sit with your companions under the stars in our private property and enjoy the lovely weather that Matheran offers all year round, u can enjoy some shooting stars around new moon nights. You can do bonfires, play your music on portable speakers. We also arrange a private barbecue on Request.
                                </p>
                                    <div className="row hotel-detail-rating">
                                        <div className="columns medium-6 small-7">
                                            <p className="m-b0 p-t10 rates">
                                                <strong className="p-r20">Very good</strong> <small className="p-r20">(22 reviews)</small>
                                                <span className='rating-box'>3.5</span> <small>/5</small>
                                            </p>
                                        </div>
                                        <div className="columns medium-6 small-5 text-right">
                                            <button className="cta">
                                                <img src="/images/icons/icon-share.png" alt="Share" /> Share
                                        </button>
                                        </div>
                                    </div>
                                    <hr className="m-tb20" />
                                    <ul className="medium-block-grid-4 small-block-grid-2 hotel-feature">
                                        <li>
                                            <small><span className="hotel-icon hotel-wifi"></span> Free Wifi</small>
                                        </li>
                                        <li>
                                            <small><span className="hotel-icon hotel-breakfast"></span> Breakfast Included</small>
                                        </li>
                                        <li>
                                            <small><span className="hotel-icon hotel-restaurant"></span> Restaurant</small>
                                        </li>
                                        <li>
                                            <small><span className="hotel-icon hotel-swimming-pool"></span> Swimming Pool</small>
                                        </li>
                                        <li>
                                            <small><span className="hotel-icon hotel-ac"></span> AC</small>
                                        </li>
                                        <li>
                                            <small><span className="hotel-icon hotel-tv"></span> TV</small>
                                        </li>
                                        <li>
                                            <small><span className="hotel-icon hotel-card"></span> Card Payment</small>
                                        </li>
                                        <li>
                                            <small><span className="hotel-icon hotel-dining"></span> Dining Area</small>
                                        </li>
                                    </ul>
                                </div>
                                <div className="columns medium-4 p-t30">
                                    <div className="hotel-booking">
                                        <h4>$203 <small>Per Night</small></h4>
                                        <label>Dates</label>
                                        <div className="date-to-end">
                                            <div className="date-to">
                                                <img src="/images/icons/small-icon-calander.png" alt="small-icon-calander" />
                                                21/10/2018
                                        </div>
                                            <span className="date-between">To</span>
                                            <div className="date-end">
                                                <img src="/images/icons/small-icon-calander.png" alt="small-icon-calander" />
                                                21/10/2018
                                        </div>
                                        </div>
                                        <label>Guests</label>
                                        <select>
                                            <option>1 Guest</option>
                                            <option>2 Guest</option>
                                        </select>
                                        <div className="clearfix m-b15">
                                            <small>$203 x 2 Night</small> <strong className="fr">$406</strong>
                                        </div>
                                        <button className="cta medium-12">Book</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Scrollbars>
                </main>
            </div> : null
            }
        </div>
    );
}

export default HotelDetailPopup;